import { Link } from 'react-router-dom';
import type { ActivitySubjectDetail, ActivitySubjectRecommendation } from '@shared/types/activity-feed';
import type { LightViewAction } from '@shared/types/views';
import { buildSubjectThreadPath } from '@/lib/thread-routes';
import { getSubjectWorkActions } from '@/lib/work-actions';
import { WorkActionCard } from '@/components/work/WorkActionCard';
interface ActivitySubjectDrawerProps {
  open: boolean;
  detail: ActivitySubjectDetail | null;
  loading: boolean;
  dismissingRecommendationId: string | null;
  onClose: () => void;
  onDismissRecommendation: (recommendation: ActivitySubjectRecommendation) => void;
  onToolHandoff: (
    recommendation: ActivitySubjectRecommendation,
    toolAction: Extract<LightViewAction, { type: 'tool_handoff' }>
  ) => void;
  onFlowHandoff: (
    recommendation: ActivitySubjectRecommendation,
    flowAction: Extract<LightViewAction, { type: 'flow_handoff' }>
  ) => void;
  onPreparePlan: (sourceRunId: string) => void;
  preparingPlanSourceRunId: string | null;
}


export const ActivitySubjectDrawer = ({open,detail,loading,onClose}: ActivitySubjectDrawerProps) => {
  if (!open) return null;
  const work = detail ? getSubjectWorkActions(detail)[0] : null;
  return <div className="fixed inset-0 z-50">
    <button type="button" aria-label="Fermer le résumé du compte" className="absolute inset-0 bg-domino-aubergine/25" onClick={onClose} />
    <aside aria-label="Résumé du compte" className="absolute inset-y-0 right-0 w-full max-w-[30rem] overflow-y-auto border-l border-domino-cardBorder bg-domino-white p-6 shadow-xl">
      <button className="float-right text-sm underline" onClick={onClose}>Fermer</button>
      {detail && <h2 className="mb-6 pr-12 text-xl font-semibold">{detail.subjectLabel}</h2>}
      {loading ? <p role="status">Chargement du compte…</p> : work ? <WorkActionCard work={work} compact /> : <p>Aucune action en attente.</p>}
      {detail && <Link onClick={onClose} className="mt-6 inline-block text-sm font-semibold text-domino-aubergine underline" to={buildSubjectThreadPath(detail)}>Ouvrir le compte</Link>}
    </aside>
  </div>;
};
